<div class="fx--h mt-sm mb-md history-wrapper">
  <div class="fx--v mr-md">
    <label class="miq-form-input-label">
      {{ 'recordsSearch.periodType' | xTranslate | titlecase }} <span class="required-icon"> &#x2a; </span>
    </label>
    <mat-form-field appearance="outline">
      <mat-select
        [formControl]="periodTypeCtrl"
        hideSingleSelectionIndicator="true"
        (selectionChange)="periodTypeChange()"
        disableOptionCentering
      >
        <mat-option value="monthly">{{ 'recordsSearch.monthly' | xTranslate }} </mat-option>
        <mat-option value="quarterly">{{ 'recordsSearch.quarterly' | xTranslate }}</mat-option>
        <mat-option value="yearly">{{ 'recordsSearch.annual' | xTranslate }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="fx--v">
    <label class="miq-form-input-label">
      {{ 'recordsSearch.period' | xTranslate }} <span class="required-icon"> &#x2a; </span>
    </label>
    <cbre-miq-quarter-selector
      [singleSelection]="false"
      [type]="periodTypeCtrl.value"
      [value]="periodCtrl.value"
      (valueChange)="periodCtrl.setValue($event)"
      [maxValue]="maxDate"
      [showAsQtd]="true"
    ></cbre-miq-quarter-selector>
  </div>
</div>
<div class="fx--h mb-sm">
  <mat-checkbox [(ngModel)]="includeHistory"> </mat-checkbox>
  <label class="miq-form-input-label history-checkbox-label">
    {{ 'recordsSearch.propertySetIncludeHist' | xTranslate }}</label
  >
</div>
<button
  mat-flat-button
  color="primary"
  [disabled]="periodCtrl?.value?.lte == null || periodCtrl?.value?.gte == null || isDownloading"
  (click)="downloadReport()"
>
  {{ (isDownloading ? 'recordsSearch.downloadingExt' : 'recordsSearch.download') | xTranslate }}
</button>
